import { ChangeDetectionStrategy, Component, OnInit, Signal, computed, input, signal } from '@angular/core';
import { TypeCoreComponent } from 'src/app/pages/type-routes/type-core.component.js';

import { FormSaveHandler } from 'lib/ui/form/form-save-button.component.js';
import { IBrandingRouteData } from 'src/app/routes/profile/branding-routes.js';
import { PublicMessageDb } from 'lib/cosmos/public-message/publicMessageDb.js';
import { map } from 'rxjs';

@Component({
    selector: 'mod-contact-form',
    templateUrl: './contact-form.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ContactFormComponent extends TypeCoreComponent<IBrandingRouteData> implements OnInit {
	public readonly enableCard = input<boolean>(true);

	public readonly emailMaxLength: number = 50;
	public readonly messagelMaxLength: number = 2000;

	public readonly messageSent = signal<boolean>(false);

	public readonly form = {
		email: signal<string | undefined>(undefined),
		message: signal<string | undefined>(undefined)
	};

	public readonly saveHandler = computed<FormSaveHandler>(() => {
		if (this.messageSent()) {
			return undefined;
		}

		const form = this.form;

		const email = form.email();
		const message = form.message();

		if (!email || !message) {
			return undefined;
		}

		return this.dependencies.httpService
			.post<PublicMessageDb.IPublicMessageItem, PublicMessageDb.IBasePublicMessageItem>((builder) => {
				return builder
					.withCustomApiRoute('publicMessage', 'send')
					.withData({
						email: email,
						message: message,
						name: `Message by ${email}`
					})
					.build();
			})
			.pipe(
				map((response) => {
					super.notify('Message has been sent');
					this.messageSent.set(true);
				})
			);
	});

	constructor() {
		super();
	}
}
